import { onAuthStateChanged, User } from "firebase/auth";
import { useEffect } from "react";

import { getFirebaseAuth } from "services/firebase/auth";
import { emitAuthStateChange } from "services/firebase/messaging-ios/messageHandlers";
import useResubscribeToPush from "services/firebase/messaging/hooks/useResubscribeToPushNotifications";

import { debounce } from "seneca-common/utils/functions";

import useAnalytics from "features/notifications/analytics/hooks/useAnalytics";

type Props = {
  children: React.ReactElement;
};

export default function NotificationsSubscriber({ children }: Props) {
  useAnalytics();

  const { resubscribeToPushNotifications } = useResubscribeToPush();

  const authFn = debounce((user: User | null) => {
    if (user) resubscribeToPushNotifications();

    emitAuthStateChange(!!user);
  }, 1000);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(getFirebaseAuth(), authFn);
    return unsubscribe;
  }, [authFn]);

  return children;
}
